'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Footer = require('./Footer.css');

var _Footer2 = _interopRequireDefault(_Footer);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = (_dec = (0, _reactCssModules2.default)(_Footer2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer(props) {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).call(this, props));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.IyvBanner, null),
        _react2.default.createElement(_components.SignupForm, null),
        _react2.default.createElement(
          'div',
          { styleName: 'footer-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'footer-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'footer-inner' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { styleName: 'footer-signup-wrap', xs: 12, sm: 12, md: 4, lg: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-first-wrap' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.ays,
                        title: 'As You Sow'
                      },
                      _react2.default.createElement('img', {
                        styleName: 'logo-ays',
                        src: aysLogo,
                        alt: 'As You Sow'
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'footer-donate-tagline' },
                      'Empowering shareholders',
                      _react2.default.createElement('br', null),
                      'to change corporations for good'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'footer-social-icons-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.socialAYSfb,
                          title: 'As You Sow Facebook' },
                        _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-facebook-official' })
                      ),
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.socialAYStwitter,
                          title: 'As You Sow Twitter' },
                        _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-twitter' })
                      ),
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.socialAYSinstagram,
                          title: 'As You Sow Instagram' },
                        _react2.default.createElement('i', { styleName: 'footer-social-icon', className: 'fa fa-instagram' })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { styleName: 'footer-signup-wrap', xs: 12, sm: 12, md: 4, lg: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-headline' },
                    'Support this work'
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.donate,
                      orangebutton: true,
                      title: 'Donate to As You Sow' },
                    'Donate',
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-heart' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'footer-signup-tagline' },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'nowrap' },
                      _config2.default.app.title
                    ),
                    ' is funded by contributions to ',
                    _react2.default.createElement(
                      'span',
                      { styleName: 'nowrap' },
                      'As You Sow'
                    ),
                    ', a ',
                    _react2.default.createElement(
                      'span',
                      { styleName: 'nowrap' },
                      'non-profit 501(c)3'
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { styleName: 'footer-signup-wrap', xs: 12, sm: 12, md: 4, lg: 4 },
                  _react2.default.createElement(_components.FooterPartner, null)
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'footer-disclaimer-links' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.legal,
                    title: 'Legal' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'white' },
                    'Legal'
                  )
                ),
                '\xA0\xA0|\xA0\xA0',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.contact,
                    title: 'Contact' },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'white' },
                    'Contact'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'footer-copyright-text' },
                'Copyright \xA9 ',
                new Date().getFullYear(),
                ' As You Sow'
              )
            )
          )
        )
      );
    }
  }]);
  return Footer;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/Footer/Footer.js
// module id = 1353
// module chunks = 0